import {OPERATOR} from '../../../constants/operator';
import {ASSETS_URL, PROMO_ASSETS_URL} from "../../../constants/endpoints";

export function getPromoBannerArray(promoBalances, bannerType, systemLanguage) {
    let bannerArray = [];
    if (OPERATOR.accaBoostBonusEnabled) {
        let bannerObj = {};
        bannerObj.id = 'Accaboost';
        bannerObj.img = `${ASSETS_URL}announcements/${bannerType}/Accaboost_${systemLanguage}.png`
        bannerArray.push(bannerObj);
    }
    if (promoBalances.length > 0) {
        if(OPERATOR.pushApiPromoToolEnabled){
            let bannerObj = {};
            bannerObj.id = promoBalances[0].PromoBetId;
            bannerObj.img = getCampaignURLPrefix(promoBalances[0].PromoBetId) + `${bannerType}_banner_${systemLanguage}.png`;
            bannerArray.push(bannerObj);
        } else{
            promoBalances.map((offer, index) => {
                let bannerObj = {};
                bannerObj.id = offer.PromoBetId;
                bannerObj.img = getCampaignURLPrefix(offer.PromoBetId) + `${bannerType}_banner_${systemLanguage}.png`;
                bannerArray.push(bannerObj);
            });
        }
    }
    return bannerArray;
}

export function getCampaignURLPrefix(PromoBetId){
    let promo = PromoBetId.split("|");
    return OPERATOR.pushApiPromoToolEnabled ? `${ASSETS_URL}${promo[0]}/` : `${PROMO_ASSETS_URL}${promo[0]}/`;
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/helpers/promoToolHelper.js